export const SLICE_NAME = "offer";
